import React, { useState } from "react";

import "../../styles/contact.css";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { faPassport, faPhoneVolume } from "@fortawesome/free-solid-svg-icons";
import { visaData } from "../../_helpers/mock-data";
import { faMessage } from "@fortawesome/free-regular-svg-icons/faMessage";



export const ContactForm = ({alertError, setDataError}) => {
    const [contactData, setContactData] = useState({
        names: '',
        email: '',
        message: '',
        phone: '',
        visa: ''
    }); 

    const isValidData = () => {
        const isNull = (v) => v === '' || v === undefined || v === null;
        const dataKeys = Object.keys(contactData);
        const isInvalid = dataKeys.some((key) => isNull(contactData[key]));
        if (isInvalid) return false;
        return true;
    }

    const handleInput = (e) => {
        setContactData((d) => ({...d, [e.target.name]: e.target.value}))
    }

    const handleSubmit = () => {
        if (!isValidData()) {
            alertError()
            setDataError()
        }
        else alert ("Email sent");
    }

    return (
        <div className='contact-section'>
            
           <div className='contact-form-box'>
                <div className="contact-box-title">
                    Contact Us
                </div>
                <div className="box-caption">
                    Do you have questions or want more
                    information?
                </div>
                <form className='contact-form'>
                    <div className='input-grp'>
                        <div className="i-cont">
                            <FontAwesomeIcon icon={faEnvelope} color="#dedede" />
                            <input
                                type="email"
                                name='email'
                                placeholder="mymail@mail.com"
                                className={classNames('c-form-input')}
                                value={contactData.email}
                                onChange={handleInput}
                            />
                        </div>
                        
                        <div className="i-cont">
                            <FontAwesomeIcon icon={faUserCircle} color="#dedede" />
                            <input
                                type="text"
                                name='names'
                                placeholder="John Doe"
                                className={classNames('c-form-input')}
                                value={contactData.names}
                                onChange={handleInput}
                            />
                        </div>
                    </div>
                    <div className='input-grp'>
                        <div className="i-cont">
                            <FontAwesomeIcon icon={faPassport} color="#dedede" />
                            <select
                                type="text"
                                name='visa'
                                className={classNames('c-form-input','c-sel')}
                                value={contactData.visa}
                                onChange={handleInput}
                            >
                                <option  value={null} >
                                    Visa type
                                </option>
                                {visaData.map((d,k) => (
                                    <option value={d} key={k} >
                                        {d}
                                    </option>
                                ))}
                            </select>
                        </div>
                        
                        <div className="i-cont">
                            <FontAwesomeIcon icon={faPhoneVolume} color="#dedede" />
                            <input
                                type="tel"
                                name='phone'
                                placeholder="+237 67..."
                                className={classNames('c-form-input')}
                                value={contactData.phone}
                                onChange={handleInput}
                            />
                        </div>
                    </div>
                    <div className="txt-cont">
                        <FontAwesomeIcon icon={faMessage} color="#dedede" />
                        <textarea
                            name='message'
                            placeholder="Type your message"
                            className={classNames('c-form-input','txt-message')}
                            value={contactData.message}
                            onChange={handleInput}
                        ></textarea>
                    </div>
                    <div>
                        <button
                            className={classNames("sub-form-button",'send-btn')}
                            onClick={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                        >
                            Send Message
                        </button>
                    </div>
                </form>
           </div>
           <div className='map-form'></div>
        </div>
    );
}